<template>
  <a-descriptions bordered size="small" :column="2">
    <a-descriptions-item>
      <div slot="label" class="center">发起人</div>
      <div class="">
        {{ detail.extra.applicant }}
      </div>
    </a-descriptions-item>

    <a-descriptions-item :span="1">
      <div slot="label" class="center">发起部门</div>
      <div class="">
        {{ detail.extra.applicantDeptName }}
      </div>
    </a-descriptions-item>
    <a-descriptions-item>
      <div slot="label" class="center">报废理由</div>
      <div class="">
        {{ detail.extra.description }}
      </div>
    </a-descriptions-item>
    <a-descriptions-item>
      <div slot="label" class="center">额度类型</div>
      <div class="">
        {{ detail.extra.creditType }}
      </div>
    </a-descriptions-item>
    <a-descriptions-item>
      <div slot="label" class="center">使用安装区域</div>
      <div class="">
        {{ detail.extra.installationArea }}
      </div>
    </a-descriptions-item>
    <a-descriptions-item>
      <div slot="label" class="center">拟报废资产计划处置方案</div>
      <div class="">
        {{ detail.extra.scrapPlan }}
      </div>
    </a-descriptions-item>
    <a-descriptions-item>
      <div slot="label" class="center">资产编码</div>
      <div class="">
        {{ list.assetCode }}
      </div>
    </a-descriptions-item>
    <a-descriptions-item>
      <div slot="label" class="center">资产类别</div>
      <div class="">
        <DataDictFinder
                    dictType="fixed_asset_type"
                    :dictValue="list.category.categoryCode"
                  />-
                  {{list.category.subCategoryName}}
      </div>
    </a-descriptions-item>
    <a-descriptions-item>
      <div slot="label" class="center">品牌型号</div>
      <div class="">
        {{ list.brandModel }}
      </div>
    </a-descriptions-item>
    <a-descriptions-item>
      <div slot="label" class="center">启用日期</div>
      <div class="">
        {{ list.startTime }}
      </div>
    </a-descriptions-item>
    <a-descriptions-item>
      <div slot="label" class="center">使用年限(月)</div>
      <div class="">
        {{ list.useMonth }}
      </div>
    </a-descriptions-item>
    <a-descriptions-item>
      <div slot="label" class="center">报废时限(月)</div>
      <div class="">
        {{ list.scrapLimitMonths }}
      </div>
    </a-descriptions-item>
    <a-descriptions-item>
      <div slot="label" class="center">财务编码</div>
      <div class="">
        {{ list.financialCode }}
      </div>
    </a-descriptions-item>
    <a-descriptions-item>
      <div slot="label" class="center">原值</div>
      <div class="">
        {{ list.purchasePrice }}
      </div>
    </a-descriptions-item>
    <a-descriptions-item>
      <div slot="label" class="center">折旧金额</div>
      <div class="">
        {{ list.depreciationPrice }}
      </div>
    </a-descriptions-item>
    <a-descriptions-item>
      <div slot="label" class="center">净残值率</div>
      <div class="">
        {{ list.netSalvageRate }}
      </div>
    </a-descriptions-item>
    <a-descriptions-item>
      <div slot="label" class="center">净值</div>
      <div class="">
        {{ list.netAmount }}
      </div>
    </a-descriptions-item>
    <a-descriptions-item>
      <div slot="label" class="center">残值</div>
      <div class="">
        {{ list.netAmount }}
      </div>
    </a-descriptions-item>
        <a-descriptions-item>
      <div slot="label" class="center">附件</div>
      <div class="">
        <a :href="detail.extra.filePath" target="_blank">下载</a>
      </div>
    </a-descriptions-item>
    <a-descriptions-item v-if="detail.taskDefinitionKey == 'inv_finance_broker' || detail.taskDefinitionKey == 'inv_finance_master' || detail.taskDefinitionKey == 'general_manager'">
      <div slot="label" class="center">入账日期</div>
      <div class="">
        <a-date-picker @change="handleDateChange" v-model="list.postingDate" :disabled="detail.taskDefinitionKey == 'inv_finance_master' || detail.taskDefinitionKey == 'general_manager'"/>
      </div>
    </a-descriptions-item>
  </a-descriptions>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
export default {
  computed: {
    ...mapState("approval", ["detail"]),
    list() {
      return this.detail.extra?this.detail.extra.fixedAsset : {};
    },
  },
  methods: {
    handleDateChange(date) {
      this.list.postingDate = moment(date).format("YYYY-MM-DD");
    },
  }
};
</script>

